import { NextPage } from "next";
import React from "react";
import { SiteContainer } from "@/src/components/SiteContainer/SiteContainer";
import IconCarousel from "@/src/components/molecules/CircleImageCarousel";
import InstagramSection from "@/src/components/molecules/Instagram";
import BlogLayout from "@/src/components/organisms/BlogLayout";
import BlogLandingHero from "../components/molecules/BlogLandingHero";
import { IDetailPreviewCard } from "@/src/@types/blog";
import { IIcon } from "@/src/components/molecules/CircleImageCarousel/Icon";
import { contentTypes } from "@/src/utils/search.constants";
import { contentTypeDefaultSorts } from "@/src/utils/search.constants";
import { BrandService } from "../BrandService";
import { StructuredData } from "../components/StructuredData";
import { Utils } from "../Utils";

export interface BlogLandingPageProps {
    blogCards: IDetailPreviewCard[];
    featuredBlogCards: IDetailPreviewCard[];
    topBlogCards: IDetailPreviewCard[];
    categories: IIcon[];
    pageNumber: number;
    totalPages: number;
    contentType: keyof typeof contentTypes;
}

const BlogLandingPage: NextPage<BlogLandingPageProps> = props => {
    const searchCategories = props.categories.map(category => ({ text: category.text, value: category.id || "", checked: false }));
    const BRAND_DATA = BrandService.getCurrentBrandData();
    const blogUrl = `${BRAND_DATA.productionUrl}/blog`;

    return (
        <SiteContainer
            title={Utils.withPageSuffix("Blog", props.pageNumber)}
            description={Utils.withPageSuffix(
                "Read the Blogbowl pet blog by Spot Pet Insurance and get the latest information, articles, and videos related to your dog or cat, or both! Learn today!",
                props.pageNumber
            )}
            displayHeaderCTA={false}
        >
            <StructuredData
                data={Utils.generateBlogSchema({
                    name: `${BRAND_DATA.name} Blog`,
                    description: "Pet care tips, wellness guides, and insurance insights for pet parents."
                })}
            />
            <StructuredData
                data={Utils.generateWebPageSchema({
                    url: blogUrl,
                    name: `Blog | ${BRAND_DATA.name}`,
                    description: "Pet care tips, wellness guides, and insurance insights for pet parents."
                })}
            />
            <StructuredData
                data={Utils.generateBreadcrumbSchema({
                    id: `${blogUrl}/#breadcrumb`,
                    items: [
                        { name: "Home", url: `${BRAND_DATA.productionUrl}/` },
                        { name: "Blog", url: blogUrl },
                        { name: "Locations", url: `${BRAND_DATA.productionUrl}/locations` },
                        { name: "Breeds", url: `${BRAND_DATA.productionUrl}/breeds` }
                    ]
                })}
            />

            <div>
                <BlogLandingHero featuredBlogCards={props.featuredBlogCards ?? []} />
                <IconCarousel title="Categories" slides={props.categories} />
            </div>
            <BlogLayout
                cards={props.blogCards}
                pageSize={9}
                pageNumber={props.pageNumber}
                totalPages={props.totalPages}
                topBlogCards={props.topBlogCards}
                pageLinkUrlFormat={"/blog/page/{{page}}"}
                categories={searchCategories}
                contentType={props.contentType}
                sortBy={contentTypeDefaultSorts.post}
            />
            <InstagramSection />
        </SiteContainer>
    );
};

export default BlogLandingPage;
